import CustomCard from '../../../../../../components/CustomCard';
import { EMPTY_VALUES } from '../../../../../../Apis/functions';
import { TrashIcon } from '../../../../../../components/buttons/IconButtons';
import React from 'react';
import NotInformation from '../../../../../../components/NotInformation';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const WorkShiftsItem = (
    {
        t,
        list,
        title = "work_shift",
        showNoInformation = true,
        onDelete=null,
        iconDelete=true
    }
) => {

    return (
        <>
            {title !== '' && <p className="fs-16px ibl-font-w-600 font-color-general-950 py-3">{t(title)}</p>}
            {list?.length > 0
                ?
                <>
                    {list?.map((item, index) => (
                        <div className="mb-2 px-0" id={`id_${item?.id || index}`} key={`key_${item?.id || index}`}>
                            <CustomCard classes="w-100" classCard="card-shades-300-100" classContent="p-10px">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="fs-14px ibl-font-w-600 font-color-general-950">{item?.name || EMPTY_VALUES.DEFAULT}</p>
                                    {iconDelete &&
                                        <div
                                            onClick={()=>{
                                                if(onDelete) onDelete(index);
                                            }}
                                        >
                                            <TrashIcon className="icon-color-shades-400 icon-hover-shades-950" width={16} height={16} />
                                        </div>
                                    }
                                </div>
                            </CustomCard>
                        </div>
                    ))}
                </>
                :
                <>{showNoInformation && <NotInformation text={t('no_work_shifts_added_yet')} card={true}/>}</>
            }
        </>

    );

}

export default WorkShiftsItem
